import Alpine from 'alpinejs';
import './plugins/Craft';
import './plugins/CookieConsent';

import accordion from './components/Accordion';
import addPackageToCart from './components/AddPackageToCart';
import addProductToCart from './components/AddProductToCart';
import ajaxForm from './components/AjaxForm';
import dialog from './components/Dialog';
import gallery from './components/Gallery';
import header from './components/Header';
import initJsStyles from './components/JsStyles';
import pageNavigation from './components/PageNavigation';
import simpleMenu from './components/SimpleMenu';
import initStickyBlock from './components/StickyBlock';
import initSwiper from './components/Swiper';
import cart from './components/Cart';
import './react';
import lineItem from './components/LineItem';
import productList from './components/ProductList';
import initCouponDialog from './components/CouponDialog';
import initNewsletterForm from './components/NewsletterForm';
import initImageZoom from './components/ImageZoom';

window.Alpine = Alpine;
window.accordion = accordion;
window.addPackageToCart = addPackageToCart;
window.addProductToCart = addProductToCart;
window.ajaxForm = ajaxForm;
window.dialog = dialog;
window.gallery = gallery;
window.header = header;
window.pageNavigation = pageNavigation;
window.simpleMenu = simpleMenu;
window.cart = cart;
window.lineItem = lineItem;
window.productList = productList;

document.addEventListener('alpine:init', () => {
  initStickyBlock();
  initSwiper();
  initJsStyles();
  initCouponDialog();
  initNewsletterForm();
  initImageZoom();
});

document.body.addEventListener('htmx:afterSwap', () => {
  initStickyBlock();
  initSwiper();
});

if (!window.alpineStarted) {
  Alpine.start();
  window.alpineStarted = true;
}

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    // eslint-disable-next-line no-console
    console.log('HMR');
  });
}
